"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cachedFetch = void 0;

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var cachedFetch = function cachedFetch(url, options) {
  var cached = sessionStorage.getItem(url);

  if (cached !== null) {
    var response = new Response(new Blob([cached]));
    return Promise.resolve(response);
  }

  return fetch(url, options).then(function (response) {
    if (response.status === 200) {
      var ct = response.headers.get('Content-Type');

      if (ct && (ct.match(/application\/json/i) || ct.match(/text\//i))) {
        response.clone().text().then(function (content) {
          sessionStorage.setItem(url, content);
        });
      }
    }

    return response;
  });
};

exports.cachedFetch = cachedFetch;